import React from "react";
import { TextField, ActionButton, ErrorText } from "../../atoms";
import T from "prop-types";
import { FaEye, FaEyeSlash } from "react-icons/fa";
{/*@TCS_START@*/ }
// const userEmail = localStorage.getItem("userEmail");
// console.log("just trying to know whatas going on with email:", userEmail);
export const ChangePasswordForm = ({
  LoginPortal,
  onChangeEmail,
  onChangePassword,
  onChangeNewPassword,
  onChangeConfirmPassword,
  validateEmail,
  errorMessage,
  email,
  password,
  newPassword,
  confirmNewPassword,
  isSubmit,
  togglePassword,
  toggleNewPassword,
  toggleConfirmNewPassword,
  isVisible,
  isNewPassVisible,
  isConfirmNewPassVisible,
  isLoading,
}) => (
  <>
    <form onSubmit={LoginPortal}>
      <div className="bottomSpace">
        <TextField
          placeholder= {email}
          defaultValue={email}
          value={email}
          mainWrapCls={"loginWrapCls"}
          disabled={true}
          onChange={(e) => onChangeEmail(e)}
          isError={
            (email === "" && isSubmit) || (isSubmit && !validateEmail(email))
              ? true
              : false
          }
          errorText={
            email === "" && isSubmit
              ? "Please enter your email"
              : isSubmit && !validateEmail(email)
                ? "Please enter a valid email"
                : null
          }
        />
      </div>
      <div className="passwordLogin">
        <TextField
          placeholder="Old Password"
          mainWrapCls={"loginWrapCls"}
          icon={
            isVisible ? (
              <FaEye className="textfield-icon" onClick={togglePassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={togglePassword} />
            )
          }
          type={isVisible ? "password" : "text"}
          isVisible={isVisible}
          togglePassword={togglePassword}
          onChange={(e) => onChangePassword(e)}
          isError={password === "" && isSubmit ? true : false}
          errorText={
            password === "" && isSubmit ? "Please enter your password" : null
          }
        />
      </div>
      <div className="passwordLogin">
        <TextField
          placeholder="New Password"
          mainWrapCls={"loginWrapCls"}
          icon={
            isNewPassVisible ? (
              <FaEye className="textfield-icon" onClick={toggleNewPassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={toggleNewPassword} />
            )
          }
          type={isNewPassVisible ? "password" : "text"}
          isNewPassVisible={isNewPassVisible}
          toggleNewPassword={toggleNewPassword}
          onChange={(e) => onChangeNewPassword(e)}
          isError={newPassword === "" && isSubmit ? true : false}
          errorText={
            newPassword === "" && isSubmit ? "Please enter new password" : null
          }
        />
      </div>
      <div className="passwordLogin">
        <TextField
          placeholder="Confirm New Password"
          mainWrapCls={"loginWrapCls"}
          icon={
            isConfirmNewPassVisible ? (
              <FaEye className="textfield-icon" onClick={toggleConfirmNewPassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={toggleConfirmNewPassword} />
            )
          }
          type={isConfirmNewPassVisible ? "password" : "text"}
          isConfirmNewPassVisible={isConfirmNewPassVisible}
          toggleConfirmNewPassword={toggleConfirmNewPassword}
          onChange={(e) => onChangeConfirmPassword(e)}
          isError={(confirmNewPassword === "" && isSubmit) || (confirmNewPassword !== newPassword && isSubmit) ? true : false}
          errorText={
            (confirmNewPassword === "" && isSubmit) || (confirmNewPassword !== newPassword && isSubmit) ? "Please confirm your new password, passwords entered dont match" : null
          }
        />
      </div>
      
      {isSubmit && errorMessage !== "" && password !== "" ? (
        <div className="errorTexttwrap">
          <ErrorText text={errorMessage} />
        </div>
      ) : null}
      <div className="btnSec">
        <ActionButton text="Change Password" isLoading={isLoading} type={"submit"} />
      </div>
    </form>
  </>
);
{/*@TCS_END@*/ }
ChangePasswordForm.T = {
  onClick: T.func,
};

ChangePasswordForm.defaultProps = {
  onClick: null,
};
